import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../../../../../../context/AuthContext";
import Swal from 'sweetalert2'
import GeneralRequestHelper from '../../../../../../../../../Helpers/GeneralRequestHelper';
import axios from "axios";
import ReactPlayer from 'react-player'
import ReactAudioPlayer from 'react-audio-player';
import { getActiveTags } from './Services/TagService'; // Yeni oluşturduğumuz servis
import { getActiveCourses, getAllActiveSubjects, getSubjectsByCourseId } from './Services/ContentService';
import { updateContent } from './Services/ContentManagerService'; // Servisi import et

const Choice = (props) => {
    const { t } = useTranslation()
    const [msg, setMsg] = useState([]);
    const { user } = useAuth();
    const [notfyText, setNotfyText] = useState([]);
    const [answer, setAnswer] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [tags, setTags] = useState([]);
    const [loadingTags, setLoadingTags] = useState(true);
    const [tagId, setTagId] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionType, setQuestionType] = useState([]);
    const [questionMedia, setQuestionMedia] = useState([]);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [imagePath] = useState([]);
    const [subjectId, setSubjectId] = useState([]);
    const [loadingSubjects, setLoadingSubjects] = useState(true);
    const [loadingCourses, setLoadingCourses] = useState(true);
    const [courses, setCourses] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [data, setData] = useState([]);
    const [multicontentsoundurl, setMulticontentsoundurl] = useState([]);

    const [serviceList, setServiceList] = useState([{ service: "" }]);
    const urlFile = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
    const headersFile = {
        "accept": "*/*",
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    };
    const taglist = async () => {
        setLoadingTags(true);
        try {
            const activeTags = await getActiveTags(user.token);
            setTags(activeTags); // Doğru yöntem: State setter kullanmak
        } catch (err) {
            setMsg(err.message || "Etiket listesi yüklenirken hata oluştu.");
        } finally {
            setLoadingTags(false);
        }
    };
    const courseList = async () => {
        setLoadingCourses(true);
        try {
            const activeCourses = await getActiveCourses(user.token);
            setCourses(activeCourses); // Doğrudan state'e ata, .push() kullanma!
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingCourses(false);
        }
    };

    const subjectlist = async () => {
        setLoadingSubjects(true);
        try {
            const activeSubjects = await getAllActiveSubjects(user.token);
            setSubjects(activeSubjects);

            // Mevcut seçili konuyu bulma mantığı
            const currentSubject = activeSubjects.find(s => s.id === props.data.subjectId);
            if (currentSubject) {
                setSubjectId(currentSubject.subjectName);
            }
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingSubjects(false);
        }
    };

    const courseselectchange = async (e) => {
        const selectedCourseId = e.target.value;
        try {
            const filteredSubjects = await getSubjectsByCourseId(selectedCourseId, user.token);
            setSubjects(filteredSubjects); // Mevcut listeyi bu sonuçla değiştirir
        } catch (err) {
            setMsg(err.message);
        }
    };

    const updateTag = async (e) => {
        e.preventDefault();
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            tagId: document.getElementById("tagId").value // Sadece tagId'yi güncelle
        };
        executeAction(payload);
    }
    const updateCourse = async (e) => {
        e.preventDefault();
        const selectedSubjectId = document.getElementById("subjectId").value;
        if (!selectedSubjectId) {
            return alert("Subject seçmediniz!");
        }
        const payload = {
            ...props.data,
            subjectId: selectedSubjectId // Sadece subjectId'yi güncelle
        };

        executeAction(payload);
    };
    const handleEdit = async (e) => {
        e.preventDefault();
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            answer: document.getElementById("correctAnswer").value // Sadece answer'ı güncelle
        };
        executeAction(payload);
    }
    const executeAction = async (payload) => {
        try {
            const res = await updateContent(payload, user.token);
            if (res.success) {
                Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Soru listesi sayfasına Dön`,
                    timer: 500,
                }).then(() => {
                    window.location.reload();
                });
            } else {
                setMsg(res.message);
            }
        } catch (err) {
            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
        }
    };


    const handleQuestion = async (e) => {
        e.preventDefault();
        var stringquestion = "";
        let questiontitle = document.getElementById("questionTitle").value.trim() || " ";
        let questiontext = document.getElementById("questionText").value.trim() || " ";
        let que = questiontitle + "__" + questiontext;
        const dataaa = JSON.parse(props.data.contentStr);
        dataaa['text'] = que;
        stringquestion = JSON.stringify(dataaa)

        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            notfyText: document.getElementById("infoBoxText").value,
            contentStr: stringquestion,
        };
        executeAction(payload);
    }

    const handleAnswerPhoto = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const list = [...serviceList];
            list[index]["photo"] = url;
            setServiceList(list);
            updateAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const { name, value } = e.target;
                    const list = [...serviceList];
                    list[index][name] = url;;
                    setServiceList(list);
                    alert("Yüklendi")
                    updateAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleAnswerVideo = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const list = [...serviceList];
            list[index]["video"] = url;
            setServiceList(list);
            updateAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const list = [...serviceList];
                    list[index]["video"] = url;;
                    setServiceList(list);
                    alert("Yüklendi")
                    updateAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };
    const handleAnswerSound = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const list = [...serviceList];
            list[index]["sound"] = url;
            setServiceList(list);
            updateAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const list = [...serviceList];
                    list[index]["sound"] = url;;
                    setServiceList(list);
                    alert("Yüklendi")
                    updateAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };
    const handleAddAnswerPhoto = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                service: " ",
                photo: url
            }
            serviceList.push(obj)
            setServiceList(serviceList)
            addAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        service: " ",
                        photo: url
                    }
                    serviceList.push(obj)
                    setServiceList(serviceList)
                    addAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleAddAnswerVideo = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                service: " ",
                video: url
            }
            serviceList.push(obj)
            setServiceList(serviceList)
            addAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        service: " ",
                        video: url
                    }
                    serviceList.push(obj)
                    setServiceList(serviceList)
                    addAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleAddAnswerSound = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                service: " ",
                sound: url
            }
            serviceList.push(obj)
            setServiceList(serviceList)
            addAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        service: " ",
                        sound: url
                    }
                    serviceList.push(obj)
                    setServiceList(serviceList)
                    addAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    }
    const addAnswer = async (index) => {
        if (document.getElementById("addedservice").value) {
            const obj = {
                service: document.getElementById("addedservice").value,
            }
            serviceList.push(obj)
            setServiceList(serviceList)
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail // Sadece detail'ı güncelle
            };
            executeAction(payload);
        }
        else {
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail // Sadece detail'ı güncelle
            };
            executeAction(payload);
        }

    }
    //----------------------------------------------
    const handleQuestionPhotoChange = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "image",
                url: url
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let photourl = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        type: "image",
                        url: photourl,
                        text: question['text']
                    }

                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };

    const handleQuestionVideoChange = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "video",
                url: url
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let urll = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        text: question['text'],
                        type: "video",
                        url: urll
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleQuestionSoundChange = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "sound",
                url: url
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const obj = {
                        text: question['text'],
                        type: "sound",
                        url: url
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    }
    const handleQuestionPhotoChangeMulti = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "image_sound",
                url: url,
                soundUrl: question['soundUrl']
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let photourl = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        type: "image_sound",
                        url: photourl,
                        soundUrl: question['soundUrl'],
                        text: question['text']
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleQuestionPhotoChangeMultiii = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "image_sound",
                url: url,
                soundUrl: question['url']
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let photourl = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        type: "image_sound",
                        url: photourl,
                        soundUrl: question['url'],
                        text: question['text']
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleQuestionSoundChangeMulti = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "image_sound",
                url: question['url'],
                soundUrl: url,
            }

            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const obj = {
                        text: question['text'],
                        type: "image_sound",
                        url: question['url'],
                        soundUrl: url,
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    }





    const deleteQuestionMediaMulti = async (e) => {
        e.preventDefault();
        if (question['type'] === "image_sound") {
            alert("Hem resim hem ses içeren sorularda medyayı tekli silmek desteklenmemektedir. Her ikisi birden silinir!");
        }
        //let questiontext = document.getElementById("questionText").value;
        var questionnnn = {
            type: "text",
            url: "",
            text: questionTitle + "__" + questionText
        }
        var stringquestion = JSON.stringify(questionnnn)
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            notfyText: document.getElementById("infoBoxText").value,
            contentStr: stringquestion,
        };
        executeAction(payload);
    }
    const addPhotoQuestion = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "image",
                url: url
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let photourl = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        type: "image",
                        url: photourl,
                        text: question['text']
                    }

                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const addVideoQuestion = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "video",
                url: url
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let urll = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const obj = {
                        text: question['text'],
                        type: "video",
                        url: urll
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const addSoundQuestion = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const obj = {
                text: question['text'],
                type: "sound",
                url: url
            }
            updateQuestionMedia(obj);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                await axios({
                    method: 'Post',
                    url: urlFile,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headersFile
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const obj = {
                        text: question['text'],
                        type: "sound",
                        url: url
                    }
                    updateQuestionMedia(obj);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    }
    const updateQuestionMedia = async (obj) => {
        var questionn = JSON.stringify(obj)
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            contentStr: questionn,

        };
        executeAction(payload);
    }
    //----------------------------------------------
    const deleteQuestionMedia = async (e) => {
        e.preventDefault();
        var questionnnn = {
            type: "text",
            url: "",
            text: questionTitle + "__" + questionText
        }
        var stringquestion = JSON.stringify(questionnnn)
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            notfyText: document.getElementById("infoBoxText").value,
            contentStr: stringquestion,
        };
        executeAction(payload);
    }



    const updateAnswer = async (index) => {
        if (index !== undefined) {
            const list = [...serviceList];
            list[index]["service"] = document.getElementById(index + ".service").value;
            setServiceList(list);
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail,
            };
            executeAction(payload);
        }
        else {
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail,
            };
            executeAction(payload);
        }
    }
    const removeAnswer = async (index) => {
        serviceList.splice(index, 1);
        setServiceList(serviceList);
        var detail = JSON.stringify(serviceList)
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            detail: detail,
        };
        executeAction(payload);
    }


    useEffect(() => {
        taglist();
        courseList();
        subjectlist();
        setTagId(JSON.parse(props.data.tagId));
        setAnswer(parseInt(props.data.answer) + 1);
        setNotfyText(props.data.notfyText);
        var questionn = JSON.parse(props.data.contentStr);
        var questionTitlee = questionn['text'].split('__')[0];
        let questionTextt = questionn['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
        if (questionn.type === "text") {
            setQuestionType("bos");
        }
        else if (questionn.type === "image_sound") {
            setQuestionType(questionn.type);
            setMulticontentsoundurl(questionn.soundUrl);
            setQuestionMedia(questionn.url);
        }
        else {
            setQuestionType(questionn.type);
            setQuestionMedia(questionn.url);
        }
        setAnswers(JSON.parse(props.data.detail));
        setServiceList(JSON.parse(props.data.detail))
        setQuestion(questionn);
    }, []);

    return (
        <div>
            <br />
            <h3>Choice // Çoktan seçmeli sorusu</h3>
            <br />
            <h5>Uyarı: Her Kısımda Güncelle butonu mevcuttur. ilgili alanda yaptığınız değişiklik sonrası güncelleme yapınız lütfen.</h5>

            <br />
            {msg}
            <div>
                <form onSubmit={updateTag}>
                    {loadingTags && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                    {!loadingTags && (
                        <div className='row' style={{ border: "1px solid black", padding: "10px" }}>
                            <div className="col-9">
                                <label htmlFor="tagId" className="form-label">{t("selecttag")}</label>
                                <select id="tagId" className="form-select" aria-label="Default select example">
                                    {tags ? (
                                        tags && tags.map((dt) => {
                                            if (dt.id === tagId) {
                                                return (
                                                    <option value={dt.id} selected>{dt.tagName}</option>
                                                );
                                            }
                                            else {
                                                return (
                                                    <option value={dt.id}>{dt.tagName}</option>
                                                );
                                            }
                                        })
                                    ) : (
                                        <p>{t("reloadWarning")}</p>
                                    )
                                    }
                                </select>
                            </div>
                            <div className='col-3'>
                                <br />
                                <div className='d-flex justify-content-center'>
                                    <button type="submit" class="btn btn-primary btn-lg" >{t("update")}</button>
                                </div>
                            </div>

                        </div>

                    )}
                </form>
                <br />
                <hr />
                <form onSubmit={updateCourse}>
                    <div style={{ border: "1px solid black", padding: "10px" }}>
                        <br />
                        <span>Aktif Subject: {subjectId}</span>
                        {loadingCourses && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                        {!loadingCourses && (
                            <div className="mb-3">
                                <label htmlFor="courseId" className="form-label">{t("selectCourse")}</label>
                                <select id="courseId" className="form-select" onChange={courseselectchange}>
                                    <option key="" >{t("selectCourse")}</option>
                                    {courses ? (
                                        courses && courses.map((dt) => {
                                            return (
                                                <option key={dt.id} value={dt.id}>{dt.courseName} -- {dt.courseDesc}</option>
                                            );
                                        })
                                    ) : (
                                        <p>{t("reloadWarning")}</p>
                                    )
                                    }
                                </select>
                            </div>
                        )}

                        {loadingSubjects && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                        {!loadingSubjects && (
                            <div className="mb-3">
                                <label htmlFor="subjectId" className="form-label">{t("selectSubject")}</label>
                                <select id="subjectId" className="form-select">
                                    <option key="" >{t("selectSubject")}</option>

                                    {subjects ? (
                                        subjects && subjects.map((dt) => {


                                            if (dt.id === data.subjectId) {
                                                return (
                                                    <option value={dt.id} selected>{dt.subjectName}  // {dt.subjectDesc}</option>
                                                );
                                            }
                                            else {
                                                return (
                                                    <option value={dt.id}>{dt.subjectName}  // {dt.subjectDesc}</option>
                                                );
                                            }
                                        })
                                    ) : (
                                        <p>{t("reloadWarning")}</p>
                                    )
                                    }
                                </select>
                            </div>

                        )}
                        <div className='d-flex justify-content-center'>
                            <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                        </div>
                    </div>
                </form>

                {questionType !== 'bos' &&
                    <div >
                        {questionType === 'image_sound' && <div style={{ border: "1px solid", padding: "1%" }}>
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div>
                                            <div className="d-flex justify-content-center">

                                                <img style={{ width: "40%" }} src={questionMedia}></img>
                                            </div><hr />
                                            <div className="mb-3">
                                                <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                                <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleQuestionPhotoChangeMulti} id="addphoto" name="addphoto" />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                                <textarea className="form-control" rows={1} type="text" onChange={handleQuestionPhotoChangeMulti} id="addphotos" name="addphotos" />
                                            </div>
                                            <br />
                                            <div className='d-flex justify-content-center'>
                                                <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMediaMulti}>Medya {t("delete")}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="d-flex justify-content-center">
                                        <div className='player-wrapper'>
                                            <ReactAudioPlayer
                                                src={multicontentsoundurl}
                                                controls
                                            />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="mb-3">
                                        <label htmlFor="videocontent" className="form-label">{t("addSound")}</label>
                                        <input className="form-control" type="file" accept='audio/*' onChange={handleQuestionSoundChangeMulti} id="videocontent" name="videocontent" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="addvideos" className="form-label">{t("addSoundbyUrl")}</label>
                                        <textarea className="form-control" rows={1} type="text" onChange={handleQuestionSoundChangeMulti} id="addvideos" name="addvideos" />
                                    </div>
                                    <br />
                                    <div className='d-flex justify-content-center'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMediaMulti}>Medya {t("delete")}</button>
                                    </div>
                                </div>

                            </div>
                            <hr />

                        </div>}
                        {questionType === 'image' && <div>
                            <div className="row" style={{ border: "1px solid", padding: "1%" }}>
                                <div className='col'>
                                    <img style={{ width: "40%" }} src={questionMedia}></img>
                                    <div>
                                        <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                        <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleQuestionPhotoChange} id="addphoto" name="addphoto" />
                                    </div>
                                    <div>
                                        <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                        <textarea className="form-control" rows={1} type="text" onChange={handleQuestionPhotoChange} id="addphotos" name="addphotos" />
                                    </div>
                                    <br />   <br />   <br />
                                    <div className='d-flex justify-content-center'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className="mb-3">
                                        <label htmlFor="videocontent" className="form-label">{t("addSound")}</label>
                                        <input className="form-control" type="file" accept='audio/*' onChange={handleQuestionSoundChangeMulti} id="videocontent" name="videocontent" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="addvideos" className="form-label">{t("addSound")}</label>
                                        <textarea className="form-control" rows={1} type="text" onChange={handleQuestionSoundChangeMulti} id="addvideos" name="addvideos" />
                                    </div>
                                </div>
                            </div>
                            <br />

                            <hr />
                        </div>}
                        {questionType === 'video' && <div>
                            <div className="d-flex justify-content-center">
                                <div className='player-wrapper'>
                                    <ReactPlayer
                                        className='react-player'
                                        url={questionMedia}
                                        controls={true}
                                    />


                                </div>
                            </div>
                            <div className="row">
                                <hr />
                                <div className="mb-3">
                                    <label htmlFor="videocontent" className="form-label">{t("addVideo")}</label>
                                    <input className="form-control" type="file" accept='video' onChange={handleQuestionVideoChange} id="videocontent" name="videocontent" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="addvideos" className="form-label">{t("addVideobyUrl")}</label>
                                    <textarea className="form-control" rows={1} type="text" onChange={handleQuestionVideoChange} id="addvideos" name="addvideos" />
                                </div>
                            </div>
                            <br />
                            <div className='d-flex justify-content-center'>
                                <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                            </div>
                        </div>}
                        {questionType === 'sound' && <div className='row' style={{ border: "1px solid", padding: "1%" }}>
                            <div className='col'>
                                <b>sadece ses dosyası vardır</b>
                                <div>
                                    <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                    <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleQuestionPhotoChangeMultiii} id="addphoto" name="addphoto" />
                                </div>
                                <div>
                                    <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                    <textarea className="form-control" rows={1} type="text" onChange={handleQuestionPhotoChangeMultiii} id="addphotos" name="addphotos" />
                                </div>
                                <br />   <br />   <br />
                                <div className='d-flex justify-content-center'>
                                    <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                </div>
                            </div>
                            <div className='col'>
                                <div className="d-flex justify-content-center">
                                    <div className='player-wrapper'>
                                        <ReactAudioPlayer
                                            src={questionMedia}
                                            controls
                                        />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="videocontent" className="form-label">{t("addSound")}</label>
                                    <input className="form-control" type="file" accept='audio/*' onChange={handleQuestionSoundChange} id="videocontent" name="videocontent" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="addvideos" className="form-label">{t("addSoundbyUrl")}</label>
                                    <textarea className="form-control" rows={1} type="text" onChange={handleQuestionSoundChange} id="addvideos" name="addvideos" />
                                </div>
                                <br />
                                <div className='d-flex justify-content-center'>
                                    <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                </div>
                            </div>
                        </div>}

                    </div>
                }
                {questionType === 'bos' && <div>
                    <h4>soru başlığında medya bulunmamaktadır. Eklemek İçin:</h4>
                    <div className="accordion accordion-flush" id="accordionFlushExample" style={{ backgroundColor: "gray" }}>
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                    <h4>{t('addFile')}</h4> <i>video ve resimler için minumum 1280*720 önerilir.</i>
                                </button>
                            </h2>
                            <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ backgroundColor: "white" }}>
                                <div className="row" style={{ padding: "1%" }}>
                                    <div className="col-md-4">
                                        <div className="mb-1">
                                            <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                            <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={addPhotoQuestion} id="addphoto" name="addphoto" required />
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                            <textarea className="form-control" rows={1} type="text" onChange={addPhotoQuestion} id="addphotos" name="addphotos" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-1">
                                            <label htmlFor="addvideo" className="form-label">{t("addVideo")}</label>
                                            <input className="form-control" type="file" accept='video' onChange={addVideoQuestion} id="addvideo" name="addvideo" required />
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="addvideos" className="form-label">{t("addVideobyUrl")}</label>
                                            <textarea className="form-control" rows={1} type="text" onChange={addVideoQuestion} id="addvideos" name="addvideos" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="mb-1">
                                            <label htmlFor="addsound" className="form-label">{t("addSound")}</label>
                                            <input className="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={addSoundQuestion} id="addsound" name="addsound" required />
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="addsounds" className="form-label">{t("addSoundbyUrl")}</label>
                                            <textarea className="form-control" rows={1} type="text" onChange={addSoundQuestion} id="addsounds" name="addsounds" />
                                        </div>
                                    </div>


                                </div>
                                <br />
                            </div>

                        </div>
                        <br />

                    </div>
                </div>}

                <form onSubmit={handleQuestion} >
                    <hr />


                    <br />
                    <div style={{ border: "1px solid black", padding: "10px" }}>
                        <div className="mb-3">
                            <label htmlFor="infoBoxText" className="form-label">{t("infoBoxText")}</label> <br />
                            <textarea className="form-control" id="infoBoxText" defaultValue={notfyText} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="questionTitle" className="form-label">{t("questionTitle")}</label><br />
                            <textarea className="form-control" id="questionTitle" defaultValue={questionTitle} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="questionText" className="form-label">{t("questionText")}</label><br />
                            <textarea className="form-control" id="questionText" defaultValue={questionText} />
                        </div>
                        <div className='d-flex justify-content-center'>
                            <button type="submit" className="btn btn-primary btn-lg">{t("update")}</button>
                        </div>
                    </div>

                </form>




                <form onSubmit={handleEdit} style={{ border: "1px solid black", padding: "10px" }}>
                    <div className="mb-3">
                        <label htmlFor="correctAnswer" className="form-label">{t("correctAnswer")}</label><br /><i>1/2/3/4/5 olarak hangi seçenek olduğunu belirtiniz lütfen. (Cevap ekle kısmında ki eklenen kaçıncı cevap olduğununun sayısal değeri </i>
                        <textarea className="form-control" id="correctAnswer" defaultValue={answer} />
                    </div>
                    <div className='d-flex justify-content-center'>
                        <button type="submit" className="btn btn-primary btn-lg">{t("update")}</button>
                    </div>
                </form>
                <br />

                <div className="d-flex justify-content-center" style={{ border: "1px solid black", fontSize: 20, textAlign: "center" }}>
                    <form>
                        {answers.map((singleService, index) => (
                            <div key={index} className="services">
                                <h1>Cevap : {index + 1}</h1>
                                <div className="first-division">
                                    <div className="row" style={{ padding: "1%" }}>
                                        <div style={{ alignContent: "center", textAlign: "center", padding: "2%" }}>
                                            <h5>Cevap Medya Dosyası</h5>
                                            <br />
                                            {singleService['photo'] &&
                                                <div className='row'>
                                                    <div className='col-md-8'>
                                                        <img src={singleService['photo']} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="mb-1">
                                                            <label htmlFor="photo" className="form-label">{t("addPhoto")}</label> <i>1:1 oranında 566*566 pixel ve üzeri </i>
                                                            <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={(e) => handleAnswerPhoto(e, index)} id="photo" name="photo" required />
                                                        </div>
                                                        <div className="mb-1">
                                                            <label htmlFor="photoUrl" className="form-label">{t("addPhotobyUrl")}</label>
                                                            <textarea className="form-control" rows={2} type="text" onChange={(e) => handleAnswerPhoto(e, index)} id="photourl" name="photoUrl" />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {singleService['video'] &&
                                                <div className='row'>
                                                    <div className='col-md-8'>
                                                        <ReactPlayer
                                                            className='react-player'
                                                            url={singleService['video']}
                                                            controls={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="mb-1">
                                                            <label htmlFor="video" className="form-label">{t("addVideo")}</label> <i>1:1 oranında </i>
                                                            <input className="form-control" type="file" accept='video' onChange={(e) => handleAnswerVideo(e, index)} id="video" name="video" required />
                                                        </div>
                                                        <div className="mb-1">
                                                            <label htmlFor="videoUrl" className="form-label">{t("addVideobyUrl")}</label>
                                                            <textarea className="form-control" rows={2} type="text" onChange={(e) => handleAnswerVideo(e, index)} id="videoUrl" name="videoUrl" />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {singleService['sound'] &&
                                                <div className='row'>
                                                    <div className="col-md-8">

                                                        <ReactAudioPlayer
                                                            src={singleService['sound']}
                                                            controls
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="mb-1">
                                                            <label htmlFor="sound" className="form-label">{t("addSound")}</label>
                                                            <input className="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={(e) => handleAnswerSound(e, index)} id="sound" name="sound" required />
                                                        </div>
                                                        <div className="mb-1">
                                                            <label htmlFor="soundUrl" className="form-label">{t("addSoundbyUrl")}</label>
                                                            <textarea className="form-control" rows={2} type="text" onChange={(e) => handleAnswerSound(e, index)} id="soundUrl" name="soundUrl" />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {!singleService['sound'] && !singleService['photo'] && !singleService['video'] &&
                                                <div>
                                                    cevapta medya bulunmamaktadır.
                                                </div>
                                            }

                                        </div>
                                    </div>

                                    <div>
                                        <h6 htmlFor="service" className="form-label">{t("answerText")}</h6> <i>{props.infoText}</i>
                                        <textarea className="form-control" name="service" id={index + ".service"} defaultValue={singleService['service']} required />
                                    </div>
                                </div>
                                <div className="second-division">
                                    <button
                                        type="button"
                                        id={index}
                                        onClick={() => updateAnswer(index)}
                                        className="remove-btn btn btn-info"
                                    >
                                        <span>Cevabı Güncelle</span>
                                    </button>
                                    &nbsp;
                                    {answers.length !== 1 && (
                                        <button
                                            type="button"
                                            onClick={() => removeAnswer(index)}
                                            className="remove-btn btn btn-danger"
                                        >
                                            <span>Cevabı Kaldır</span>
                                        </button>
                                    )}
                                </div>

                            </div>
                        ))}

                    </form>
                </div>


                <hr />
                {answers.length < 6 && (
                    <div style={{ border: "1px solid black", padding: "2%" }}>
                        <h3>Cevap Ekle</h3>
                        <form>
                            <div className="services">
                                <div className="first-division">
                                    <div className="row" style={{ padding: "1%" }}>
                                        <div className="col-md-4">
                                            <div class="mb-1">
                                                <label for="photo" class="form-label">{t("addPhoto")}</label> <i>1:1 oranında 566*566 pixel ve üzeri </i>
                                                <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={(e) => handleAddAnswerPhoto(e)} id="photo" name="photo" required />
                                            </div>
                                            <div class="mb-1">
                                                <label for="photoUrl" class="form-label">{t("addPhotobyUrl")}</label>
                                                <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAddAnswerPhoto(e)} id={"photourl"} name="photoUrl" />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div class="mb-1">
                                                <label for="video" class="form-label">{t("addVideo")}</label> <i>1:1 oranında </i>
                                                <input class="form-control" type="file" accept='video' onChange={(e) => handleAddAnswerVideo(e)} id="video" name="video" required />
                                            </div>
                                            <div class="mb-1">
                                                <label for="videoUrl" class="form-label">{t("addVideobyUrl")}</label>
                                                <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAddAnswerVideo(e)} id="videoUrl" name="videoUrl" />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div class="mb-1">
                                                <label for="sound" class="form-label">{t("addSound")}</label>
                                                <input class="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={(e) => handleAddAnswerSound(e)} id="sound" name="sound" required />
                                            </div>
                                            <div class="mb-1">
                                                <label for="soundUrl" class="form-label">{t("addSoundbyUrl")}</label>
                                                <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAddAnswerSound(e)} id="soundUrl" name="soundUrl" />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <h6 for="service" class="form-label">{t("answerText")}</h6><i>boş ise 1 ader boşluk giriniz. (sadece video/resim/ses var ise)</i> <i>{props.infoText}</i>
                                        <textarea class="form-control" name="service" id="addedservice" required />
                                        <hr />
                                        <button className='btn btn-info' id="" onClick={addAnswer}>{t('save')}</button>
                                    </div>

                                    <br />
                                    <br />

                                </div>

                            </div>
                        </form>
                    </div>
                )}

            </div>
        </div>
    );
};

export default Choice;